import React, { useContext } from "react";
import { ContentContext } from "@/pages/Layout";
import PageCover from "@/components/PageCover";
import { useApp } from "@/context/AppContext";

export default function About() {
  const content = useContext(ContentContext);
  const { t, loc } = useApp();

  return (
    <div data-testid="about-page">
      <PageCover testId="about-cover" image={content?.covers?.about} overline="BEDAS" title={t("about")} />

      <section className="px-6 md:px-12 py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-14">
          <div className="md:col-span-4">
            <p className="overline">{t("about")}</p>
            <div className="gold-line mt-5 w-24" />
          </div>
          <p data-testid="about-text" className="md:col-span-8 text-base md:text-lg text-neutral-300 leading-relaxed whitespace-pre-line font-light">
            {loc(content?.about)}
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 py-20 md:py-28 bg-[#080808] border-y border-white/5">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
          {[["vision", content?.vision], ["mission", content?.mission]].map(([k, v]) => (
            <div key={k} data-testid={`about-${k}`}>
              <p className="overline">{t(k)}</p>
              <div className="gold-line mt-5 w-16" />
              <p className="mt-8 font-serif text-2xl md:text-3xl font-light text-neutral-200 leading-snug whitespace-pre-line">{loc(v)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
